import { useNavigate } from 'react-router-dom';
import { useLang } from '../context/LangContext';
import { IMAGES } from '../data/menuData';
import { SOCIAL } from '../data/socialLinks';
import './Follow.css';

const FacebookIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path fill="currentColor" d="M22 12.06C22 6.5 17.52 2 12 2S2 6.5 2 12.06C2 17.08 5.66 21.24 10.44 22v-7.03H7.9v-2.91h2.54V9.85c0-2.52 1.49-3.91 3.77-3.91 1.09 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.78-1.63 1.57v1.89h2.78l-.45 2.91h-2.33V22C18.34 21.24 22 17.08 22 12.06Z" />
  </svg>
);

const InstagramIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path fill="currentColor" d="M12 2.16c3.2 0 3.58.01 4.85.07 1.17.05 1.8.25 2.23.41.56.22.96.48 1.38.9.42.42.68.82.9 1.38.16.42.36 1.06.41 2.23.06 1.27.07 1.65.07 4.85s-.01 3.58-.07 4.85c-.05 1.17-.25 1.8-.41 2.23-.22.56-.48.96-.9 1.38-.42.42-.82.68-1.38.9-.42.16-1.06.36-2.23.41-1.27.06-1.65.07-4.85.07s-3.58-.01-4.85-.07c-1.17-.05-1.8-.25-2.23-.41a3.8 3.8 0 0 1-1.38-.9 3.8 3.8 0 0 1-.9-1.38c-.16-.42-.36-1.06-.41-2.23C2.17 15.58 2.16 15.2 2.16 12s.01-3.58.07-4.85c.05-1.17.25-1.8.41-2.23.22-.56.48-.96.9-1.38.42-.42.82-.68 1.38-.9.42-.16 1.06-.36 2.23-.41C8.42 2.17 8.8 2.16 12 2.16Zm0 1.98c-3.15 0-3.52.01-4.76.07-1.15.05-1.77.24-2.19.4-.55.22-.94.47-1.35.88-.41.41-.66.8-.88 1.35-.16.42-.35 1.04-.4 2.19-.06 1.24-.07 1.61-.07 4.76s.01 3.52.07 4.76c.05 1.15.24 1.77.4 2.19.22.55.47.94.88 1.35.41.41.8.66 1.35.88.42.16 1.04.35 2.19.4 1.24.06 1.61.07 4.76.07s3.52-.01 4.76-.07c1.15-.05 1.77-.24 2.19-.4.55-.22.94-.47 1.35-.88.41-.41.66-.8.88-1.35.16-.42.35-1.04.4-2.19.06-1.24.07-1.61.07-4.76s-.01-3.52-.07-4.76c-.05-1.15-.24-1.77-.4-2.19a3.6 3.6 0 0 0-.88-1.35 3.6 3.6 0 0 0-1.35-.88c-.42-.16-1.04-.35-2.19-.4-1.24-.06-1.61-.07-4.76-.07Zm0 3.37a5.49 5.49 0 1 1 0 10.98 5.49 5.49 0 0 1 0-10.98Zm0 9.05a3.56 3.56 0 1 0 0-7.12 3.56 3.56 0 0 0 0 7.12Zm6.99-9.27a1.28 1.28 0 1 1-2.56 0 1.28 1.28 0 0 1 2.56 0Z" />
  </svg>
);

const TikTokIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path fill="currentColor" d="M16.6 5.82A4.28 4.28 0 0 1 15.54 3h-3.09v12.4a2.59 2.59 0 0 1-2.59 2.5 2.59 2.59 0 1 1 .77-5.06v-3.1a5.65 5.65 0 0 0-.77-.05A5.68 5.68 0 1 0 15.54 15.4V9.01a7.35 7.35 0 0 0 4.3 1.38V7.3a4.28 4.28 0 0 1-3.24-1.48Z" />
  </svg>
);

const GoogleIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path fill="#4285F4" d="M21.6 12.23c0-.7-.06-1.37-.18-2.02H12v3.82h5.38a4.6 4.6 0 0 1-2 3.02v2.5h3.24c1.89-1.74 2.98-4.3 2.98-7.32Z" />
    <path fill="#34A853" d="M12 22c2.7 0 4.96-.9 6.62-2.43l-3.24-2.51c-.9.6-2.05.96-3.38.96-2.6 0-4.8-1.76-5.59-4.12H3.06v2.59A10 10 0 0 0 12 22Z" />
    <path fill="#FBBC05" d="M6.41 13.9a6 6 0 0 1 0-3.8V7.5H3.06a10 10 0 0 0 0 9l3.35-2.6Z" />
    <path fill="#EA4335" d="M12 5.98c1.47 0 2.79.51 3.83 1.5l2.87-2.87C16.95 2.99 14.7 2 12 2A10 10 0 0 0 3.06 7.5l3.35 2.6C7.2 7.74 9.4 5.98 12 5.98Z" />
  </svg>
);

export default function Follow() {
  const { lang, setLang, t } = useLang();
  const navigate = useNavigate();

  const actions = [
    {
      key: 'facebook',
      brand: 'facebook',
      icon: <FacebookIcon />,
      label: t('follow.facebook'),
      sub: t('follow.facebook.sub'),
      href: SOCIAL.facebook,
    },
    {
      key: 'instagram',
      brand: 'instagram',
      icon: <InstagramIcon />,
      label: t('follow.instagram'),
      sub: t('follow.instagram.sub'),
      href: SOCIAL.instagram,
    },
    {
      key: 'tiktok',
      brand: 'tiktok',
      icon: <TikTokIcon />,
      label: t('follow.tiktok'),
      sub: t('follow.tiktok.sub'),
      href: SOCIAL.tiktok,
    },
    {
      key: 'google',
      brand: 'google',
      icon: <GoogleIcon />,
      label: t('follow.google'),
      sub: t('follow.google.sub'),
      href: SOCIAL.googleReview,
    },
  ];

  return (
    <div className="follow-page">
      <div className="follow-photo" style={{ backgroundImage: `url(${IMAGES.hero})` }} />
      <div className="follow-overlay" />

      <div className="lang-switcher follow-lang">
        <button className={"lang-btn" + (lang === 'fr' ? ' active' : '')} onClick={() => setLang('fr')}>FR</button>
        <button className={"lang-btn" + (lang === 'en' ? ' active' : '')} onClick={() => setLang('en')}>EN</button>
      </div>

      <div className="follow-content">
        <img src="/gemiya-logo.png" alt="Gemiya" className="follow-logo" />
        <div className="follow-eyebrow">{t('follow.eyebrow')}</div>
        <h1 className="follow-title">{t('follow.title')}</h1>
        <p className="follow-desc">{t('follow.desc')}</p>

        <div className="follow-buttons">
          {actions.map(a => (
            <a
              key={a.key}
              className={`follow-btn follow-btn--${a.brand}`}
              href={a.href}
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="follow-btn-icon">{a.icon}</span>
              <span className="follow-btn-text">
                <span className="follow-btn-label">{a.label}</span>
                <span className="follow-btn-sub">{a.sub}</span>
              </span>
              <span className="follow-btn-arrow">→</span>
            </a>
          ))}
        </div>

        <div className="follow-stars" aria-hidden="true">★ ★ ★ ★ ★</div>
        <p className="follow-thanks">{t('follow.thanks')}</p>

        <button className="follow-back" onClick={() => navigate('/')}>{t('follow.back')}</button>
      </div>
    </div>
  );
}
